import { Typography, Button, useMediaQuery } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import React, { ReactElement, ReactNode } from "react";
import { useDropzone } from "react-dropzone";
import { CameraAlt } from "@material-ui/icons";
import Translator from "../services/Translator";
import { useVi } from "../contexts/ViContext";

const useStyles = makeStyles((theme: Theme) => ({
  dropZone: {
    width: "100%",
    height: "100%",
    border: `dashed 2px ${theme.palette.divider}`,
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    outline: "none",
    padding: "1rem",
    minHeight: "min-content",
    boxSizing: "border-box",
  },
  uploadBtnContainer: {
    paddingBottom: "2em",
  },
  buttonWrapper: {
    display: "flex",
    placeContent: "center",
    placeItems: "center",
  },
}));

function ImageUpload({
  dropZone = false,
  add = false,
  children,
  noClick = false,
}: {
  dropZone?: boolean;
  add?: boolean;
  children?: ReactNode;
  noClick?: boolean;
}): ReactElement {
  const classes = useStyles();
  const { onImageLoad } = useVi();
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => onImageLoad(files, add),
    accept: "image/jpeg,image/png",
    noClick,
  });

  return (
    <>
      {!useMediaQuery((theme: Theme) => theme.breakpoints.down("xs")) && dropZone ? (
        <div className={classes.dropZone} {...getRootProps()}>
          <input {...getInputProps()} />
          <div className={classes.uploadBtnContainer}>
            <Button
              size="small"
              color="secondary"
              endIcon={<CameraAlt />}
              variant="contained"
            >
              {Translator.translate("components.imageupload.upload_photos")}
            </Button>
          </div>
          <Typography id="dropthemhere">
            {Translator.translate("components.imageupload.dropthemhere")}
          </Typography>
        </div>
      ) : (
        <div className={classes.buttonWrapper} {...getRootProps()}>
          <input {...getInputProps()} />
          {children || (
            <Button size="small" color="secondary" variant="contained">
              {Translator.translate("components.imageupload.upload_photos")}
            </Button>
          )}
        </div>
      )}
    </>
  );
}

export default ImageUpload;
